import { BaseBrandedItem, PrintingMethod } from '@/graphql/types/generated';
import { CellContext } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { DataTableColumn } from '@/components/DataTable';
import CopyableText from '../CopyableText';
import ImageThumbnail from '../Index/ImageThumbnail';

const ImageCell = ({ getValue }: CellContext<ItemColumns, string[]>) => {
  const imageUrls = getValue();
  // placeholder space for items w/ no image
  if (!imageUrls[0]) return <div sx={{ width: '40px', height: '10px' }} />;

  return (
    <ImageThumbnail
      imgUrl={imageUrls[0]}
      styles={{ maxWidth: '40px', maxHeight: '60px' }}
    />
  );
};

export const EditLinkCell = ({ row }: CellContext<ItemColumns, unknown>) => {
  if (row.original.printingMethod === PrintingMethod.External) {
    return null;
  }

  return (
    <Link
      to={`/base_branded_item/edit/${row.original.id}`}
      sx={{
        variant: 'styles.a',
        color: 'primaryHover',
        fontWeight: 'bold',
        display: 'table',
        margin: '0 auto',
      }}
    >
      ✏️
    </Link>
  );
};

const NameCell = ({ row, getValue }: CellContext<ItemColumns, string>) => {
  return (
    <div sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <div sx={{ fontWeight: 'semibold', color: 'neutralDark' }}>
        {getValue()}
      </div>
      <div sx={{ variant: 'text.minorNote' }}>
        <CopyableText
          sx={{ display: 'inline-flex' }}
          title="Click to copy UUID"
        >
          {row.original.id}
        </CopyableText>
      </div>
    </div>
  );
};

export type ItemColumns = BaseBrandedItem & {
  edit?: undefined;
};

export const itemTableColumns: DataTableColumn<ItemColumns>[] = [
  {
    header: 'Image',
    accessorKey: 'imageUrls',
    cell: ImageCell,
    enableSorting: false,
  },
  {
    header: 'Name',
    accessorKey: 'name',
    cell: NameCell,
  },
  {
    header: 'Unit',
    id: 'unit',
    accessorFn: (row) => row.salesUnit.name,
    enableSorting: false,
  },
  {
    header: 'Category',
    id: 'category',
    accessorFn: (row) => row.category.name,
  },
  {
    header: 'Subcategory',
    id: 'subcategory',
    accessorFn: (row) => row.subcategory.name,
  },
  {
    header: '✏️',
    id: 'edit',
    cell: EditLinkCell,
    enableSorting: false,
  },
];
